import { CompanyInfo } from './company';
import { FFL } from './general';

export class Accounting {
  expense_records: Expense[] = [];
  sales_records: SalesReceipt[] = [];
  products_services: ProductServiceItem[] = [];
  payment_accounts: string[] = [];
  payment_methods: string[] = [];
  categories: string[] = [
    'Shipping',
    'Office Supplies',
    'Rent',
    'Utilities',
    'Meals & Entertainment',
    'Travel',
    'Advertising',
    'Insurance',
    'Legal & Professional Services',
    'Repairs & Maintenance',
    'Other',
  ];
  inventory_asset_accounts: string[] = [
    'Inventory Asset',
    'Furniture & Equipment',
  ];
  vendors: string[] = ['RSR Group', `Lipsey's`, `Davidson's`];
  income_expense_accounts: Account[] = [
    { type: 'Income', name: 'Merchandise Sales' },
    { type: 'Income', name: 'Billable Expanse Income' },
    { type: 'Income', name: 'Cash' },
    { type: 'Expense', name: 'Cost of Goods Sold' },
    { type: 'Expense', name: 'Merchant Services Fees' },
  ];
  customers: Customer[] = [];
  sales_tax_options: salesTax[] = [
    Object.assign(new salesTax(), { name: 'Exempt', state_rate: 0 }),
    Object.assign(new salesTax(), { name: 'Idaho Sales Tax', state_rate: 0.06 }),
  ];
}
export class Expense {
  id?: string;
  company_id?: string;
  type: string;
  payee: string;
  payee_id: string;
  payment_account: string;
  payment_date: Date;
  payment_method: string;
  reference_number: string;
  category_details: CategoryDetails[] = [];
  item_details: ItemDetails[] = [];
  category: string;
  memo: string;
  due_date: Date;
  balance: number;
  total: number;
  attachments: any[] = [];
  status: string;
  updatedAt?: string;
}
export class CategoryDetails {
  category: string;
  description: string;
  amount: number;
}
export class ItemDetails {
  id?: string;
  product_service: string;
  description: string;
  qty: number;
  rate: number;
  amount: number;
  tax: boolean;
}

export class Vendor {
  id?: string = null;
  company_id?: string = null;
  contact_id: string = null;
  contact_type: string = 'Vendor';
  contact: Contact = new Contact();
  address: Address = new Address();
  ach_payments: AchPayments = new AchPayments();
  memo: string;
  attachments: any[] = [];
  ffl: FFL = new FFL();
  updatedAt?: string;
}
export class Customer {
  id?: string = null;
  company_id?: string = null;
  contact_id: string = null;
  contact_type: string = 'Customer';
  contact: Contact = new Contact();
  address: Address = new Address();
  tax_option: salesTax = new salesTax();
  memo: string;
  attachments: any[] = [];
  updatedAt?: string;
}

export class Contact {
  company_name: string | null = null;
  display_name: string | null = null;
  name_title: string | null = null;
  name_first: string | null = null;
  name_middle: string | null = null;
  name_last: string | null = null;
  name_suffix: string | null = null;
  email: string | null = null;
  phone_number: string | null = null;
  fax_number: string | null = null;
  website: string | null = null;
  name_to_print_on_checks: string | null = null;
  other: string | null = null;
}
export class Address {
  street: string | null = null;
  street2: string | null = null;
  city: string | null = null;
  state: string | null = null;
  zip_code: string | null = null;
  country: string | null = null;
}
export class AchPayments {
  account_number: string | null = null;
  routing_number: string | null = null;
}
export class SalesReceipt {
  id?: string;
  company_id?: string;
  sales_receipt_number: string;
  type: string;
  customer_id: string;
  customer_name?: string;
  email: string;
  billing_address: Address = new Address();
  receipt_date: string;
  sales_rep: string;
  payment_method: string;
  reference_number: string;
  sales_items: SalesItem[] = [];
  message_on_receipt: string;
  message_on_statement: string;
  subtotal: number;
  taxable_subtotal: number;
  sales_tax_rate: number;
  total: number;
  amount_received: number;
  balance_due: number;
  status: string;
  updatedAt?: string;
}
export class SalesReceiptPrint {
  sales_receipt: SalesReceipt;
  company_info: CompanyInfo;
}
export class salesTax {
  name: string;
  state_rate: number = 0;
  county_rate: number = 0;
  city_rate: number = 0;
  special_rate: number = 0;
  /** @deprecated Legacy field — use component rates. Kept for backward-compat with existing DB data. */
  tax_rate?: number;
  get combined_rate(): number {
    const componentSum = (this.state_rate || 0) + (this.county_rate || 0) + (this.city_rate || 0) + (this.special_rate || 0);
    if (componentSum === 0 && this.tax_rate != null) return this.tax_rate;
    return componentSum;
  }
}
export class SalesItem {
  service_date: Date;
  product_service: string;
  description: string;
  firearm: boolean;
  serial_number: string[] = [];
  qty: number;
  rate: number;
  amount: number;
  tax: boolean;
}

export class Service {
  name: string;
  category: string;
  description: string;
  qty: number;
  sale_price_rate: number;
  service_amount: number;
  sales_tax: boolean;
}

export class ProductServiceItem {
  id: string = null;
  company_id?: string;
  name: string = null;
  upc?: string = null;
  type: string = null;
  category: string = null;
  description: string = null;
  serial_item: boolean = null;
  sale_price_rate: number = null;
  cost?: number = null;
  income_asset_account: string = null;
  income_account: string = null;
  expense_account: string = null;
  inventory_asset_account?: string = null;
  reorder_point?: number = null;
  sales_tax: boolean = null;
  preferred_vendor?: string = null;
  active: boolean = null;
  archived: boolean = null;
  /** Weighted average cost per unit — updated by the COGS calculator service */
  avg_cost?: number = null;
  /** Unit cost of the most recent purchase lot */
  last_cost?: number = null;
  updatedAt?: string;
}
export class Account {
  type: string;
  name: string;
}

export class EditCustomerResponsePackage {
  customer: Customer;
  rowIndex: number;
}
export class EditVendorResponsePackage {
  vendor: Vendor;
  rowIndex: number;
}
export class PaymentHistory {
  statement_date: string;
  invoice_number: string;
  account_number: string;
  contact: string;
  ffl: string;
  company_name: string;
  address_street: string;
  address_city: string;
  address_state: string;
  address_zip_code: string;
  subscription_type: string;
  subscription_amount: string;
}

export const PaymentMethods = [
  'ACH',
  'American Express',
  'Cash',
  'Check',
  'Debit Card',
  'Discover Card',
  'MasterCard',
  'Money Order',
  'PayPal',
  'Venmo',
];
export const DepositAccounts = ['PayPal', 'Venmo', 'Bank Account'];

export const FormStatus = {
  pending: 'Pending',
  paid: 'Paid',
  void: 'Void',
  deleted: 'Deleted',
};
export const Title = ['Mr', 'Ms', 'Mrs', 'Miss'];

// ---------------------------------------------------------------------------
// Cost accounting — inventory lots & transactions
// ---------------------------------------------------------------------------

export type CostingMethod = 'FIFO' | 'LIFO' | 'Average';

export class InventoryLot {
  _id?: string;
  company_id: string;
  item_id: string;
  date: Date;
  qty: number;
  qty_remaining: number;
  unit_cost: number;
  vendor?: string;
  reference_number?: string;
  notes?: string;
  createdAt?: string;
  updatedAt?: string;
}

export class LotConsumed {
  lot_id: string;
  qty_consumed: number;
  unit_cost: number;
}

export class InventoryTransaction {
  _id?: string;
  company_id: string;
  item_id: string;
  transaction_type: 'purchase' | 'sale' | 'adjustment' | 'return' | 'void';
  date: Date;
  qty: number;
  unit_cost?: number;
  cogs?: number;
  costing_method?: CostingMethod;
  lots_consumed: LotConsumed[];
  reference_id?: string;
  reference_type?: string;
  notes?: string;
  createdAt?: string;
}
